import MDBox from "./MDBox";

function MyMDBox(props: any) {
  return <MDBox {...props} />;
}

export default MyMDBox;
